// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[snippet-carousel] .__pagination[data-v-0df84561]{-webkit-mask-image:linear-gradient(270deg,transparent 0,#000 3rem,#000 calc(100% - 3rem),transparent 100%);mask-image:linear-gradient(270deg,transparent 0,#000 3rem,#000 calc(100% - 3rem),transparent 100%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
